import React from 'react';
import './styles.less';
import { Row, Col } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import useMobileBreakpoint from '../../../hooks/useMobileBreakpoint';

const Footer = () => {
  const isMobile = useMobileBreakpoint();

  const className = classNames('footer', {
    'footer--sm': isMobile,
    'footer--lg': !isMobile,
  });

  return (
    <Row className={className}>
      <Col lg={12} xs={24}>
        <div className="footer--text-bold">
          <p>VanTrust Capital | Asesoría y Gestión Integral de Inversiones</p>
        </div>
        <div className="footer--color">
          <p>Santiago | Av. Cerro el Plomo 5420, piso 18, Las Condes.</p>
          <p>Viña del Mar | 12 Norte 785 Of.403, Edificio Pamplona.</p>
          <p>2021 | www.vantrustcapital.cl</p>
        </div>
      </Col>
      <Col lg={12} xs={24}>
        <div className="footer--color-align">
          <Row>
            <Col lg={12} xs={24}>
              <p>Inicio</p>
            </Col>
            <Col lg={11} xs={24}>
              <p>Sugerencia y Reclamos</p>
            </Col>
          </Row>
          <Row>
            <Col lg={12} xs={24}>
              <p>Hágase Cliente</p>
            </Col>
            <Col lg={11} xs={24}>
              <p>Contacto</p>
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={{ span: 24 }}>
              <p style={{ fontWeight: 'bold' }}>
                <RightOutlined />
                Barómetro de valores y ética Profesional
              </p>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};
export default Footer;
